import React from 'react';

import { RCCheckbox } from '@reverbdotcom/cadence/components';
import { FilterOption } from './search_filters';
import { useUpdateUrl } from './with_update_url';
import { withRouter, WithRouterProps } from 'react-router';
import { SelectFacetOptionCount, linkParams } from './select_facet_option';

interface IExternalProps {
  option: FilterOption;
  trackInteraction: () => void;
}

type IProps = IExternalProps & WithRouterProps;

export function SelectFacetCheckboxComponent({
  option,
  location,
  router,
  trackInteraction,
}: IProps) {
  const [loading, setLoading] = React.useState(false);
  const { updateUrl } = useUpdateUrl();

  React.useEffect(() => {
    setLoading(false);
  }, [option.selected]);

  const zeroCount = option.count?.value === 0;

  function handleChange(event) {
    if (zeroCount) {
      event.preventDefault();
      return;
    }

    const newUrl = updateUrl({
      location,
      newParams: linkParams(option, true),
    });

    trackInteraction();

    setLoading(true);
    router.push(newUrl);
  }

  return (
    <RCCheckbox
      id={`${option.paramName}-${option.optionValue}`}
      checked={loading ? !option.selected : option.selected}
      disabled={zeroCount}
      onChange={handleChange}
      label={(
        <>
          <span className="mr-space">{option.name}</span>
          <SelectFacetOptionCount option={option} />
        </>
      )}
    />
  );
}

export const SelectFacetCheckbox = withRouter(SelectFacetCheckboxComponent);
